// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    fapiPublicGetV1Ping (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Ping (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1Time (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Time (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1ExchangeInfo (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3ExchangeInfo (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1Depth (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Depth (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1Trades (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Trades (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1HistoricalTrades (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3HistoricalTrades (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1AggTrades (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3AggTrades (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1Klines (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Klines (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1IndexPriceKlines (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3IndexPriceKlines (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1MarkPriceKlines (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3MarkPriceKlines (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1PremiumIndex (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3PremiumIndex (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1FundingRate (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3FundingRate (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1FundingInfo (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3FundingInfo (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1Ticker24hr (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Ticker24hr (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1TickerPrice (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3TickerPrice (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1TickerBookTicker (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3TickerBookTicker (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1AdlQuantile (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV1ForceOrders (params?: {}): Promise<implicitReturnType>;
    fapiPublicGetV3Indexreferences (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1PositionSideDual (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3PositionSideDual (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1MultiAssetsMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3MultiAssetsMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1Order (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Order (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1OpenOrder (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3OpenOrder (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1OpenOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3OpenOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1AllOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3AllOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV2Balance (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Balance (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Account (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1PositionMarginHistory (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3PositionMarginHistory (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV2PositionRisk (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3PositionRisk (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1UserTrades (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3UserTrades (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1Income (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Income (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1LeverageBracket (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3LeverageBracket (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV1CommissionRate (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3CommissionRate (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3AdlQuantile (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3ForceOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Mmp (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3AccountWithJoinMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV4Account (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Agent (params?: {}): Promise<implicitReturnType>;
    fapiPrivateGetV3Builder (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1PositionSideDual (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3PositionSideDual (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1MultiAssetsMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3MultiAssetsMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1Order (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3Order (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1OrderTest (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3OrderTest (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1BatchOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3BatchOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1AssetWalletTransfer (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3AssetWalletTransfer (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1CountdownCancelAll (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3CountdownCancelAll (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1Leverage (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3Leverage (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1MarginType (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3MarginType (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1PositionMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3PositionMargin (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV1ListenKey (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3ListenKey (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3Mmp (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3MmpReset (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3Noop (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3ApproveAgent (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3UpdateAgent (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3ApproveBuilder (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePostV3UpdateBuilder (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePutV1ListenKey (params?: {}): Promise<implicitReturnType>;
    fapiPrivatePutV3ListenKey (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV1Order (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3Order (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV1AllOpenOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3AllOpenOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV1BatchOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3BatchOrders (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3Mmp (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV1ListenKey (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3ListenKey (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3Agent (params?: {}): Promise<implicitReturnType>;
    fapiPrivateDeleteV3Builder (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1Ping (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1Time (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1ExchangeInfo (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1Depth (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1Trades (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1HistoricalTrades (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1AggTrades (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1Klines (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1Ticker24hr (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1TickerPrice (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1TickerBookTicker (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV1AsterWithdrawEstimateFee (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3Ping (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3Time (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3ExchangeInfo (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3Depth (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3Trades (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3HistoricalTrades (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3AggTrades (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3Klines (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3Ticker24hr (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3TickerPrice (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3TickerBookTicker (params?: {}): Promise<implicitReturnType>;
    sapiPublicGetV3AsterWithdrawEstimateFee (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1CommissionRate (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1Order (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1OpenOrders (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1AllOrders (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1TransactionHistory (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1Account (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV1UserTrades (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3CommissionRate (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3Order (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3OpenOrders (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3AllOrders (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3Account (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3UserTrades (params?: {}): Promise<implicitReturnType>;
    sapiPrivateGetV3OpenOrder (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV1Order (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV1AssetWalletTransfer (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV1AssetSendToAddress (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV1ListenKey (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV3Order (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV3AssetWalletTransfer (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV3AsterUserWithdraw (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePostV3ListenKey (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePutV1ListenKey (params?: {}): Promise<implicitReturnType>;
    sapiPrivatePutV3ListenKey (params?: {}): Promise<implicitReturnType>;
    sapiPrivateDeleteV1Order (params?: {}): Promise<implicitReturnType>;
    sapiPrivateDeleteV1AllOpenOrders (params?: {}): Promise<implicitReturnType>;
    sapiPrivateDeleteV1ListenKey (params?: {}): Promise<implicitReturnType>;
    sapiPrivateDeleteV3AllOpenOrders (params?: {}): Promise<implicitReturnType>;
    sapiPrivateDeleteV3Order (params?: {}): Promise<implicitReturnType>;
    sapiPrivateDeleteV3ListenKey (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
